const recurringInput = {
  frequency: {
    title: 'Defina como este turno se repete ao longo do tempo',
    values: {
      dontRepeat: 'Não se repete',
      day: 'Diário',
      week: 'Semanal',
      month: 'Mensal',
    },
    labels: {
      day: 'dia(s)',
      week: 'semana(s)',
      month: 'mês(es)',
    },
  },
  repeatEvery: 'Repetir a Cada',
  repeatOn: 'Repetir em',
  repeatOnNote: 'Selecione pelo menos um dia',
  ends: 'Termina em',
  endsOn: 'Finaliza em',
  endsLabels: {
    never: 'Nunca termina',
    date: `Até {{date}}`,
    times: 'Após {{number}} ocorrências',
  },
  windowNote: 'Por enquanto, apenas os primeiros {{count}} turnos são criados. Os demais são gerados automaticamente por um processo em segundo plano ao longo do tempo.',
  endsDateNote: 'A data de término selecionada é muito cedo - nenhum turno seria criado. Escolha uma data posterior.',

  form: {
    month: 'Mês',
    day: 'Dia',
    week: 'Semana',
    year: 'Ano',
    occurrences: 'Ocorrências',
    after: 'Depois',
    never: 'Nunca',
    on: 'Em',
  },
};

export default recurringInput;
